var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author
 * @file radioGroup
 * @author (zhaomiaoyuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import { inputLoop, classPrefix, EleResize } from '../../common/util';

import Radio from './Radio';

import './Radio.less';

/* global getComputedStyle */

/**
 * 参数说明
 * name            单选组合时必需
 * style           非必需，自定义样式
 * formFlag        非必需，form组件中专用
 * increment       非必需，form专用，唯一标识
 * validate        非必需，form专用，验证结果
 * value           必需，选中的值
 * label           非必需，radioGroup左侧文案；
 * tips            非必需，radioGroup右侧文案；
 * horizontal      非必需，默认false；为true时，radioGroup样式display:inline-block；
 * noWarning       非必需，警告提示；
 * layout          非必需，默认false横向展示，为true纵向展示
 * className       非必需，类名
 * onHandleChange  选项变化时的回调函数(form用)
 * getValue        选项变化时的回调函数
 * classPrefix     非必需，类名前缀
 */

var RadioGroup = function (_Component) {
    _inherits(RadioGroup, _Component);

    function RadioGroup(props) {
        _classCallCheck(this, RadioGroup);

        var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

        _initialiseProps.call(_this);

        var name = _this.props.name;
        var loop = inputLoop();
        _this.__name = name === null ? loop : name;
        _this.state = { layout: false };

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;
        _this.formCallback(_this.props.value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(RadioGroup, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.value, this.props.value)) {
                this.formCallback(np.value, this.FORM_NEED_VALIDATE);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                responsive = _props.responsive,
                layout = _props.layout;

            if (layout || !responsive) {
                // 如果是垂直布局或者非响应式模式，直接跳过
                return;
            }
            this.resizeHandler();
            EleResize.on(this.radioWrapper, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);

            var _props2 = this.props,
                responsive = _props2.responsive,
                layout = _props2.layout;

            if (layout || !responsive) {
                // 如果是垂直布局或者非响应式模式，直接跳过
                return;
            }
            EleResize.off(this.radioWrapper, this.resizeHandler);
        }
    }, {
        key: 'renderRadioGroup',
        value: function renderRadioGroup() {
            var _this2 = this;

            var propsValue = this.props.value;
            var _props3 = this.props,
                name = _props3.name,
                formFlag = _props3.formFlag,
                layout = _props3.layout,
                responsive = _props3.responsive,
                theme = _props3.theme;

            var panels = this.props.children;
            var realLayout = responsive && !layout ? this.state.layout : layout;
            return React.Children.map(panels, function (child) {
                if (!child) {
                    return;
                }
                var _child$props = child.props,
                    children = _child$props.children,
                    value = _child$props.value,
                    disabled = _child$props.disabled;

                if (realLayout) {
                    // 外层的div，是为了垂直布局，并且被保留内部radio的所占宽度，便于计算
                    return React.createElement(
                        'div',
                        { key: value },
                        React.createElement(
                            Radio,
                            {
                                name: name,
                                checked: value === propsValue,
                                value: value,
                                formFlag: formFlag,
                                onChange: _this2.radioChange,
                                layout: false,
                                disabled: disabled,
                                theme: theme
                            },
                            children
                        )
                    );
                } else {
                    return React.createElement(
                        Radio,
                        {
                            key: value,
                            name: name,
                            checked: value === propsValue,
                            value: value,
                            formFlag: formFlag,
                            onChange: _this2.radioChange,
                            layout: false,
                            disabled: disabled,
                            theme: theme
                        },
                        children
                    );
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var _props4 = this.props,
                validate = _props4.validate,
                label = _props4.label,
                tips = _props4.tips,
                horizontal = _props4.horizontal,
                noWarning = _props4.noWarning,
                className = _props4.className,
                classPrefix = _props4.classPrefix,
                responsive = _props4.responsive;

            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-radio-group', true), _defineProperty(_classnames, 'display-i-b', horizontal === true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _defineProperty(_classnames, 'responsive', responsive), _classnames));

            return React.createElement(
                'div',
                { className: rootClass },
                label && React.createElement(
                    'div',
                    { className: classPrefix + '-form-label' },
                    label
                ),
                React.createElement(
                    'div',
                    {
                        className: 'label-style',
                        ref: function ref(el) {
                            _this3.radioWrapper = el;
                        }
                    },
                    this.renderRadioGroup(),
                    !noWarning && validate && validate.message && React.createElement(
                        'div',
                        { className: classPrefix + '-form-warning' },
                        React.createElement('i', { className: classPrefix + '-form-error' }),
                        validate.message
                    )
                ),
                tips && React.createElement(
                    'span',
                    { className: classPrefix + '-form-tips' },
                    tips
                )
            );
        }
    }]);

    return RadioGroup;
}(Component);

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.resizeHandler = function () {
        var wrapperWidth = parseFloat(getComputedStyle(_this4.radioWrapper).width);
        var children = _this4.radioWrapper.querySelectorAll('.radio-block');
        var childrenWidth = 0;
        for (var i = 0; i < children.length; i++) {
            childrenWidth += parseFloat(getComputedStyle(children[i]).width);
        }

        if (wrapperWidth <= childrenWidth) {
            _this4.setState({ layout: true });
        } else {
            _this4.setState({ layout: false });
        }
    };

    this.formCallback = function (data, type, isDelete) {
        var _props5 = _this4.props,
            formFlag = _props5.formFlag,
            name = _props5.name,
            increment = _props5.increment,
            onHandleChange = _props5.onHandleChange;


        if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
            onHandleChange({
                name: name,
                value: data
            }, _this4, type, increment, isDelete);
        }
    };

    this.radioChange = function (e) {
        var _props6 = _this4.props,
            getValue = _props6.getValue,
            name = _props6.name;

        if (getValue && _.isFunction(getValue)) {
            getValue({
                name: name,
                value: e.target.value
            });
        }
    };
};

export default RadioGroup;


RadioGroup.defaultProps = {
    classPrefix: classPrefix,
    theme: 'green'
};

RadioGroup.propTypes = {
    name: PropTypes.string,
    style: PropTypes.object,
    formFlag: PropTypes.bool,
    increment: PropTypes.any,
    validate: PropTypes.any,
    value: PropTypes.string,
    label: PropTypes.node,
    tips: PropTypes.node,
    horizontal: PropTypes.bool,
    noWarning: PropTypes.bool,
    layout: PropTypes.bool,
    checked: PropTypes.number,
    onHandleChange: PropTypes.func,
    getValue: PropTypes.func,
    children: PropTypes.array,
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    responsive: PropTypes.bool,
    theme: PropTypes.oneOf(['green', 'blue'])
};